module.exports = __webpack_public_path__ + "images/stickers/frown.b5c44de3bf6dd36cf8bc.png";